export default __webpack_public_path__ + "static/media/logo-sm1.24f44841.svg";